import { defineMessages } from 'react-intl';

const messages = defineMessages({
  learnMore: {
    description: 'advancedS:earch.orders.filters.learnMore',
    defaultMessage: 'Learn more',
    id: 'bysNer',
  },
  moreCriteria: {
    description: 'advancedSearch.orders.filters.moreCriteria',
    defaultMessage: 'To add more criteria, filter within your search results.',
    id: '1cfDnO',
  },
  search: {
    description: 'advancedSearch.orders.filters.search',
    defaultMessage: 'Search',
    id: 'fs8Vfj',
  },
  reset: {
    description: 'advancedSearch.orders.filters.reset',
    defaultMessage: 'Reset',
    id: 'O5PoQh',
  },
});

export default messages;
